export default __webpack_public_path__ + "static/media/SignUp.af2b8598.jpg";